import React from "react";
import { RouteComponentProps } from "react-router";

import withTitle from "../withTitle";
import { V1 } from "../../Api";
import { formatDateLocal } from "../../Utilities";

interface IMetricsFairBookingViewState {
    isLoading: boolean | string;

    fairs: any[];
}

interface IMetricsFairBookingViewProps extends RouteComponentProps<any> {

}

class MetricsFairBookingView extends React.Component<IMetricsFairBookingViewProps, IMetricsFairBookingViewState> {
    constructor(props: Readonly<IMetricsFairBookingViewProps>) {
        super(props);

        const state: IMetricsFairBookingViewState = {
            isLoading: true,

            fairs: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="col-smallest">Created</th>
                            <th>Name</th>
                            <th>Scheduled For</th>
                            <th>City</th>
                            <th className="col-smallest">Head Count</th>
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Fairs Created</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.isLoading === true
                            ? <tr>
                                <td colSpan={10}><div className="spinner spinner-center lds-dual-ring" /></td>
                            </tr>
                            : typeof this.state.isLoading === "string"
                                ? <tr>
                                    <td colSpan={10}><span className="error-text">{this.state.isLoading}</span></td>
                                </tr>
                                : this.state.fairs.map(a => <tr key={a.id} className="clickable" onClick={() => this.goFair(a.id)}>
                                    <td>{formatDateLocal(a.creationTimestamp)}</td>
                                    <td>{a.name}</td>
                                    <td>{formatDateLocal(a.scheduledDate)}</td>
                                    <td>{a.address.city}, {a.address.state}</td>
                                    <td><span className={a.estimatedHeadCount >= 20 ? "time-active" : undefined}>{a.estimatedHeadCount}</span></td>
                                </tr>)
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            const parameters = [
                "mode=creation",
                `person=${this.props.match.params.id}`,
                `after=${this.props.match.params.after}`,
                `before=${this.props.match.params.before}`,
            ];

            const data = await V1.get<any[]>(`fairs/summary?${parameters.join("&")}`);

            this.setState({
                isLoading: false,

                fairs: data
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load fairs"
            });
        }
    }

    private goFair(id: string) {
        this.props.history.push(`/fairs/${id}`);
    }
}

export default withTitle("Booked Heatlh Fairs", MetricsFairBookingView);
